<template>
  <VApp>
    <DefaultHeader />

    <VMain>
      <VContainer fluid>
        <ErrorManagement v-if="errorStore.hasFatalError" />
        <slot v-else />
      </VContainer>
    </VMain>

    <DefaultFooter />
  </VApp>
</template>

<script lang="ts" setup>
import DefaultHeader from '@/layouts/DefaultHeader.vue';
import DefaultFooter from '@/layouts/DefaultFooter.vue';
import ErrorManagement from '@/components/ErrorManagement.vue';
import { useErrorsStore } from '@/stores/errorStore.ts';

const errorStore = useErrorsStore();
</script>
